import { DeeplinkScreen } from '@/screens/Deeplink';
import { ExternalTaskPage } from '@/screens/ExternalTask/pages/ExternalTaskPage';
import EventReportsRoute from '@/screens/monitoring/EventReports/Route';
import AnswerReport from '@/screens/monitoring/AnswerReport/Route';
import EventPicturesReportsRoute from '@/screens/monitoring/EventPicturesReports/Route';
import React from 'react';
import { Route, RouteProps, Switch, useRouteMatch } from 'react-router-dom';
import { TermsOfUse } from '@/screens/Policy';

const ExternalRoutes: React.FC<RouteProps> = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        path={`${path}/event/:id/answers/images`}
        component={EventPicturesReportsRoute}
      />
      <Route path={`${path}/event/:id`} component={EventReportsRoute} />
      <Route path={`${path}/answers/:id`} component={AnswerReport} />
      <Route path={`${path}/deep_link`} component={DeeplinkScreen} />
      <Route path={`${path}/task/:id`} component={ExternalTaskPage} />
      <Route path={`${path}/terms`} component={TermsOfUse} />
    </Switch>
  );
};

export default ExternalRoutes;
